<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Companies List</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button>
      <button mat-raised-button color="primary" [disabled]="isExporting" (click)="onExportToCsv()">
        <mat-icon>insert_chart_outlined</mat-icon>
        CSV Export
      </button>
      @if (isAdmin) {
        <button mat-raised-button color="primary" (click)="onCreateCompany()">
          <mat-icon>add</mat-icon>
          Add Company
        </button>
      }
    </div>
  </div>
  <app-company-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    [fieldsConfig]="searchFieldsConfig"
    (companySearchFilter)="onCompanySearchFilterChange($event)">
  </app-company-search-box>
  <app-generic-list
    [items]="companies"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [enableEdit]="true"
    [enableLink]="true"
    linkTooltip="Open in new tab"
    [enableDelete]="isAdmin"
    [serverSidePagination]="true"
    [totalItems]="totalItems"
    [currentPage]="currentPage"
    (editClick)="onEditCompany($event)"
    (linkClick)="onOpenCompanyInNewTab($event)"
    (deleteClick)="onDeleteCompany($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)">
  </app-generic-list>
</div>
